import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import classNames from 'classnames';

import { PatientRecordABCDataList, SavePatientRecordABCData } from '../../actions/BehaviourDataActions';
import { renderDateField, renderTimePicker, renderAutoCompleteSingleSelect, renderCheckBox, renderTextArea } from '../../../../../../../../components/reduxFields';
import Loader from '../../../../../../../../img/loader.gif';
//import Tooltip from '../../../../../../../../components/Tooltip';
import RecordABCDataViewModal from './RecordABCDataViewModal';
import AddBehaviourModal from './Modals/AddBehaviourModal';
import AddAntecedentModal from './Modals/AddAntecedentsModal';
import AddConsequencesModal from './Modals/AddConsequencesmodal';
import AddLocationsModal from './Modals/AddLocationsModal';

const minuteArray = [
    { id: 1, value: "01" }, { id: 2, value: "02" }, { id: 3, value: "03" }, { id: 4, value: "04" }, { id: 5, value: "05" }, { id: 6, value: "06" }, { id: 7, value: "07" }, { id: 8, value: "08" }, { id: 9, value: "09" }, { id: 10, value: "10" },
    { id: 11, value: "11" }, { id: 12, value: "12" }, { id: 13, value: "13" }, { id: 14, value: "14" }, { id: 15, value: "15" }, { id: 16, value: "16" }, { id: 17, value: "17" }, { id: 18, value: "18" }, { id: 19, value: "19" }, { id: 20, value: "20" },
    { id: 21, value: "21" }, { id: 22, value: "22" }, { id: 23, value: "23" }, { id: 24, value: "24" }, { id: 25, value: "25" }, { id: 26, value: "26" }, { id: 27, value: "27" }, { id: 28, value: "28" }, { id: 29, value: "29" }, { id: 30, value: "30" },
    { id: 31, value: "31" }, { id: 32, value: "32" }, { id: 33, value: "33" }, { id: 34, value: "34" }, { id: 35, value: "35" }, { id: 36, value: "36" }, { id: 37, value: "37" }, { id: 38, value: "38" }, { id: 39, value: "39" }, { id: 40, value: "40" },
    { id: 41, value: "41" }, { id: 42, value: "42" }, { id: 43, value: "43" }, { id: 44, value: "44" }, { id: 45, value: "45" }, { id: 46, value: "46" }, { id: 47, value: "47" }, { id: 48, value: "48" }, { id: 49, value: "49" }, { id: 50, value: "50" },
    { id: 51, value: "51" }, { id: 52, value: "52" }, { id: 53, value: "53" }, { id: 54, value: "54" }, { id: 55, value: "55" }, { id: 56, value: "56" }, { id: 57, value: "57" }, { id: 58, value: "58" }, { id: 59, value: "59" }
]

const secondArray = [
    { id: 1, value: "01" }, { id: 2, value: "02" }, { id: 3, value: "03" }, { id: 4, value: "04" }, { id: 5, value: "05" }, { id: 6, value: "06" }, { id: 7, value: "07" }, { id: 8, value: "08" }, { id: 9, value: "09" }, { id: 10, value: "10" },
    { id: 11, value: "11" }, { id: 12, value: "12" }, { id: 13, value: "13" }, { id: 14, value: "14" }, { id: 15, value: "15" }, { id: 16, value: "16" }, { id: 17, value: "17" }, { id: 18, value: "18" }, { id: 19, value: "19" }, { id: 20, value: "20" },
    { id: 21, value: "21" }, { id: 22, value: "22" }, { id: 23, value: "23" }, { id: 24, value: "24" }, { id: 25, value: "25" }, { id: 26, value: "26" }, { id: 27, value: "27" }, { id: 28, value: "28" }, { id: 29, value: "29" }, { id: 30, value: "30" },
    { id: 31, value: "31" }, { id: 32, value: "32" }, { id: 33, value: "33" }, { id: 34, value: "34" }, { id: 35, value: "35" }, { id: 36, value: "36" }, { id: 37, value: "37" }, { id: 38, value: "38" }, { id: 39, value: "39" }, { id: 40, value: "40" },
    { id: 41, value: "41" }, { id: 42, value: "42" }, { id: 43, value: "43" }, { id: 44, value: "44" }, { id: 45, value: "45" }, { id: 46, value: "46" }, { id: 47, value: "47" }, { id: 48, value: "48" }, { id: 49, value: "49" }, { id: 50, value: "50" },
    { id: 51, value: "51" }, { id: 52, value: "52" }, { id: 53, value: "53" }, { id: 54, value: "54" }, { id: 55, value: "55" }, { id: 56, value: "56" }, { id: 57, value: "57" }, { id: 58, value: "58" }, { id: 59, value: "59" }
]

const stylescss = {
    checkbox: {
        marginBottom: 16,
    },
};

// const validate = (values) => {
//     const errors = {};
//     if (!values.Minute) {
//         errors.Minute = 'Please select Minute';
//     }
//     if (!values.Second) {
//         errors.Second = 'Please select Second';
//     }
//     return errors;
// };

class RecordABCData extends Component {


    constructor(props) {
        super(props);
        this.state = {
            patientId: props.patientId ? props.patientId : null,
            FromDate: new Date(),
            Time: new Date(),
            creadteDate: props.creadteDate,
            PatientAntecedentsReductionData: [],
            PatientBehaviorsReductionData: [],
            PatientConsequencesReductionData: [],
            PatientLocationsReductionData: [],
            patientRecordABCDataDetailsModel: [],
            todayRecordABCDataViewModal: false,
            addBehaviourModalOpen: false,
            addAntecedentModalOpen: false,
            addConsequencesModalOpen: false,
            addLocationsModalOpen: false
        }
        this.onDateChange = this.onDateChange.bind(this);
    }

    componentWillMount = () => {
        this.props.PatientRecordABCDataList(this.state.patientId)
    }

    onDateChange = (input, value) => {
        input.onChange(moment(value).format());
        this.setState({
            [input.name]: value,
        });
    }

    submitABCData(formProps) {
        let Minute = formProps.Minute || 0;
        let Second = formProps.Second || 0;
        if(Minute < 10) {
            Minute =  "0"+Minute
        }
        if(Second < 10) {
            Second =  "0"+Second
        }
        let finalTimeInterval = Minute + '.' + Second;
        let postData = {
            "id": 0,
            "patientId": parseInt(this.state.patientId),
            "sessionId": this.props.uuid,
            "sessionDate": moment(this.state.FromDate).format('YYYY-MM-DD'),
            "sessionTime": moment(this.state.FromDate).format('YYYY-MM-DD') + 'T' + moment(this.state.Time).format('HH:mm:ss'),
            "timeInterval": parseFloat(finalTimeInterval),
            "notes": formProps.Note ? formProps.Note : null,
            "patientRecordABCDataDetailsModel": this.state.patientRecordABCDataDetailsModel
        }
        this.props.SavePatientRecordABCData(postData);
        this.props.dispatch(reset('RecordABCDataForm'))
        this.setState({
            patientRecordABCDataDetailsModel : []
        })
    }

    renderLoading() {
        if (this.state.isLoading) {
            return (
                <div className="full_loader">
                    <div className="circle_loader page_loader">
                        <img src={Loader} alt="" />
                    </div>
                </div>
            );
        }
    }

    
    todayRecordABCDataView = () => {
        this.setState({
            todayRecordABCDataViewModal : true
        })  
    }

    handleChange = (input, selectedRecord) => {
        input.onChange(selectedRecord.value);
    }

    handleClose = (type) => {
        if(type === "recordABCDataModal") {
            this.setState({
                todayRecordABCDataViewModal: false,
            })
        } else {
            this.setState({
                addBehaviourModalOpen: false,
                addAntecedentModalOpen: false,
                addConsequencesModalOpen: false,
                addLocationsModalOpen: false
            })
        }
    }

    addBehaviourModalHandler = () => {
        this.setState({
            addBehaviourModalOpen: true
        })
    }

    addAntecedentsModalHandler = () => {
        this.setState({
            addAntecedentModalOpen: true
        })
    }

    addConsequencesModalHandler = () => {
        this.setState({
            addConsequencesModalOpen: true
        })
    }

    addLocationsModalHandler = () => {
        this.setState({
            addLocationsModalOpen: true
        })
    }

    checkRecordABCData = (e, index, Obj, type) => {
        let PatientBehaviorsReductionData = this.state.PatientBehaviorsReductionData;
        let PatientAntecedentsReductionData = this.state.PatientAntecedentsReductionData;
        let PatientConsequencesReductionData = this.state.PatientConsequencesReductionData;
        let PatientLocationsReductionData = this.state.PatientLocationsReductionData;
        let patientRecordABCDataDetailsModel = this.state.patientRecordABCDataDetailsModel;
        let isChecked = e.target.checked;
        if(isChecked) {
            if (type === "PatientAntecedentsReductionData") {
                let data = {
                    "recordABCDataDetailId": 0,
                    "recordABCDataId": 0,
                    "antecedentsReductionId": Obj.id,
                    "behaviorsReductionId": null,
                    "consequencesReductionId": null,
                    "locationsReductionId": null,
                    "value": 1
                }
                PatientAntecedentsReductionData.push(Obj)
                patientRecordABCDataDetailsModel.push(data);
            } else if (type === "PatientBehaviorsReductionData") {
                let data = {
                    "recordABCDataDetailId": 0,
                    "recordABCDataId": 0,
                    "antecedentsReductionId": null,
                    "behaviorsReductionId": Obj.id,
                    "consequencesReductionId": null,
                    "locationsReductionId": null,
                    "value": 1
                }
                PatientBehaviorsReductionData.push(Obj)
                patientRecordABCDataDetailsModel.push(data);
            } else if (type === "PatientConsequencesReductionData") {
                let data = {
                    "recordABCDataDetailId": 0,
                    "recordABCDataId": 0,
                    "antecedentsReductionId": null,
                    "behaviorsReductionId": null,
                    "consequencesReductionId": Obj.id,
                    "locationsReductionId": null,
                    "value": 1
                }
                PatientConsequencesReductionData.push(Obj)
                patientRecordABCDataDetailsModel.push(data);
            } else if (type === "PatientLocationsReductionData") {
                let data = {
                    "recordABCDataDetailId": 0,
                    "recordABCDataId": 0,
                    "antecedentsReductionId": null,
                    "behaviorsReductionId": null,
                    "consequencesReductionId": null,
                    "locationsReductionId": Obj.id,
                    "value": 1
                }
                PatientLocationsReductionData.push(Obj);
                patientRecordABCDataDetailsModel.push(data);
            }
        } else {
            index = patientRecordABCDataDetailsModel.findIndex((value) => {
                if(type === "PatientAntecedentsReductionData") {
                   return value.antecedentsReductionId === Obj.id
                } else if(type === "PatientBehaviorsReductionData") {
                   return  value.behaviorsReductionId === Obj.id
                } else if(type === "PatientConsequencesReductionData") {
                   return  value.consequencesReductionId === Obj.id
                } else if(type === "PatientLocationsReductionData") {
                   return value.locationsReductionId === Obj.id
                }
            });
            if (index >= 0) {
                patientRecordABCDataDetailsModel.splice(index, 1);
            }
        }
       
        this.setState({
            PatientBehaviorsReductionData: PatientBehaviorsReductionData,
            PatientAntecedentsReductionData: PatientAntecedentsReductionData,
            PatientConsequencesReductionData: PatientConsequencesReductionData,
            PatientLocationsReductionData: PatientLocationsReductionData,
            patientRecordABCDataDetailsModel: patientRecordABCDataDetailsModel
        });
    }

    renderData = (type, dataList) => {
        let PatientAntecedentsReductionData = dataList || [];
        let PatientBehaviorsReductionData = dataList || [];
        let PatientConsequencesReductionData = dataList || [];
        let PatientLocationsReductionData = dataList || [];
            if (!PatientAntecedentsReductionData.length && !PatientBehaviorsReductionData.length && !PatientConsequencesReductionData.length && !PatientLocationsReductionData.length) {
                return (
                    <tr>
                        <td colSpan='3'>
                            <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                        </td>
                    </tr>
                );
            }
            if (type === "PatientAntecedentsReductionData") {
                return PatientAntecedentsReductionData.map((Obj, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                {Obj.antecedentName}
                            </td>
                            <td>
                                {Obj.description}
                            </td>
                            <td>
                                <div className="table_custom-check">
                                    <Field
                                        name={`CheckPatientAntecedentsReductionData[${index}].Chk`}
                                        component={renderCheckBox}
                                        onChange={(e) => this.checkRecordABCData(e, index, Obj, "PatientAntecedentsReductionData")}
                                        style={stylescss.checkbox}
                                    />
                                </div>
                            </td>
                        </tr>
                    )
                })
            } else if (type === "PatientBehaviorsReductionData") {
                return PatientBehaviorsReductionData.map((Obj, index) => {
                    return (
                        <tr key={index}>
                            <td> 
                                {Obj.behaviorName}
                            </td>
                            <td>
                                {Obj.description}
                            </td>
                            <td>
                                <div className="table_custom-check">
                                    <Field
                                        name={`CheckPatientBehaviorsReductionData[${index}].Chk`}
                                        component={renderCheckBox}
                                        onChange={(e) => this.checkRecordABCData(e, index, Obj, "PatientBehaviorsReductionData")}
                                        style={stylescss.checkbox}
                                    />
                                </div>
                            </td>
                        </tr>
                    )
                })
            } else if (type === "PatientConsequencesReductionData") {
                return PatientConsequencesReductionData.map((Obj, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                {Obj.consequenceName}
                            </td>
                            <td>
                                {Obj.description}
                            </td>
                            <td>
                                <div className="table_custom-check">
                                    <Field
                                        name={`CheckPatientConsequencesReductionData[${index}].Chk`}
                                        component={renderCheckBox}
                                        onChange={(e) => this.checkRecordABCData(e, index, Obj, "PatientConsequencesReductionData")}
                                        style={stylescss.checkbox}
                                    />
                                </div>
                            </td>
                        </tr>
                    )
                })
            } else if (type === "PatientLocationsReductionData") {
                return PatientLocationsReductionData.map((Obj, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                {Obj.locationName}
                            </td>
                            <td>
                                {Obj.description}
                            </td>
                            <td>
                                <div className="table_custom-check">
                                    <Field
                                        name={`CheckPatientLocationsReductionData[${index}].Chk`}
                                        component={renderCheckBox}
                                        onChange={(e) => this.checkRecordABCData(e, index, Obj, "PatientLocationsReductionData")}
                                        style={stylescss.checkbox}
                                    />
                                </div>
                            </td>
                        </tr>
                    )
                })
            }
    }

    renderRecordABCData = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { recordABCDataList } = this.props;
        let PatientRecordABCDataList = (recordABCDataList && recordABCDataList.data) || [];
        return (
            <div className="table-responsive mt-15">
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="40%">Behaviors<i className="fa fa-plus-square ml_15" aria-hidden="true" onClick={() => this.addBehaviourModalHandler()}></i></th>
                            <th width="50%"></th>
                            <th width="10%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData("PatientBehaviorsReductionData", PatientRecordABCDataList.PatientBehaviorsReductionData)}

                    </tbody>
                </table>
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="40%">Antecedents<i className="fa fa-plus-square ml_15" aria-hidden="true" onClick={() => this.addAntecedentsModalHandler()}></i></th>
                            <th width="50%"></th>
                            <th width="10%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData("PatientAntecedentsReductionData", PatientRecordABCDataList.PatientAntecedentsReductionData)}
                    </tbody>
                </table>
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="40%">Consequences<i className="fa fa-plus-square ml_15" aria-hidden="true" onClick={() => this.addConsequencesModalHandler()}></i></th>
                            <th width="50%"></th>
                            <th width="10%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData("PatientConsequencesReductionData", PatientRecordABCDataList.PatientConsequencesReductionData)}

                    </tbody>
                </table>
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="40%">Locations<i className="fa fa-plus-square ml_15" aria-hidden="true" onClick={() => this.addLocationsModalHandler()}></i></th>
                            <th width="50%"></th>
                            <th width="10%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData("PatientLocationsReductionData", PatientRecordABCDataList.PatientLocationsReductionData)}
                    </tbody>
                </table>
            </div>
        )
    }


    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                {this.renderLoading()}
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form" onSubmit={handleSubmit(this.submitABCData.bind(this))}>
                            <div className="row">
                                <div className="col-sm-3 require">
                                    <Field
                                        name="FromDate"
                                        placeholder="Select Date"
                                        locale="en-US"
                                        selected={this.state.FromDate}
                                        onDateChange={this.onDateChange}
                                        openToYearSelection={true}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-3 require">
                                    <Field
                                        name="Time"
                                        placeholder="Time"
                                        fullWidth={true}
                                        component={renderTimePicker}
                                        selected={this.state.Time}
                                        onDateChange={this.onDateChange}
                                    />
                                </div>
                                <div className="col-sm-3 mt-35">
                                    <Field
                                        name="Minute"
                                        label="Minute"
                                        handleNewRequest={this.handleChange}
                                        options={minuteArray}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                                <div className="col-sm-3 mt-35">
                                    <Field
                                        name="Second"
                                        label="Second"
                                        handleNewRequest={this.handleChange}
                                        options={secondArray}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                                </div>
                                <div className="row">                                
                                    <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter">
                                        {this.props.addPermissionBehavior && <RaisedButton
                                            style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                                            disabled={this.state.patientRecordABCDataDetailsModel.length > 0 ? false : true}
                                            type="Submit"
                                            primary={true}>Save</RaisedButton>}                                
                                        <RaisedButton
                                            style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                                            className="ml_15"
                                            onClick={() => this.todayRecordABCDataView()}
                                            label="Today's ABC Data"
                                            primary={true}>
                                        </RaisedButton>
                                    </div>
                                </div>
                                <div className="row">
                                <div className="col-sm-12">
                                    {this.renderRecordABCData()}
                                </div>
                                <div className="col-sm-12 mt-20">
                                    <Field
                                        name="Note"
                                        label="Note"
                                        type="text"
                                        maxLength="1000"
                                        component={renderTextArea}
                                        fullWidth={true}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                {
                    this.state.todayRecordABCDataViewModal &&
                     <RecordABCDataViewModal
                      patientId={this.state.patientId}
                      creadtedDate={moment().format('YYYY-MM-DDTHH:mm:ss')}
                      uuid={this.props.uuid}
                      closeDialog={() => this.handleClose('recordABCDataModal')}
                      updatePermissionBehavior = {this.props.updatePermissionBehavior}
                      deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                      />
                }
                {
                    this.state.addBehaviourModalOpen && 
                    <AddBehaviourModal 
                       patientId={this.state.patientId}
                       closeDialog={() => this.handleClose()}
                    />
                }
                 {
                    this.state.addAntecedentModalOpen && 
                    <AddAntecedentModal 
                       patientId={this.state.patientId}
                       closeDialog={() => this.handleClose()}
                    />
                }
                {
                    this.state.addConsequencesModalOpen &&
                    <AddConsequencesModal
                        patientId={this.state.patientId}
                        closeDialog={() => this.handleClose()}
                    />
                }
                {
                    this.state.addLocationsModalOpen &&
                    <AddLocationsModal
                        patientId={this.state.patientId}
                        closeDialog={() => this.handleClose()}
                    />
                }
            </div>
        )
    }
}

RecordABCData = reduxForm({
    form: 'RecordABCDataForm',
    // validate,
    enableReinitialize: true,
})(RecordABCData);

function mapStateToProps(state) {
    return {
        recordABCDataList: state.patientBehaviourData.recordABCDataList !== null ? state.patientBehaviourData.recordABCDataList : [],
        uuid: state.patientSkillAcqActiveProgram.uuid,
    }
}

export default connect(mapStateToProps, { PatientRecordABCDataList, SavePatientRecordABCData })(RecordABCData);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordABCData/RecordABCData.js